var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomigRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 17C5 15.5778 6.33333 14.3043 6.33333 12.7333C6.33333 11.1624 5.13942 9.88889 3.66667 9.88889C2.19391 9.88889 1 11.1624 1 12.7333C1 14.3043 2.33333 15.5778 3.66667 17ZM3.66667 17H13.8889C15.1162 17 16.1111 16.0051 16.1111 14.7778C16.1111 13.5505 15.1162 12.5556 13.8889 12.5556H11.6667M14.3333 8.11111C15.6667 6.68889 17 5.41539 17 3.84444C17 2.2735 15.8061 1 14.3333 1C12.8605 1 11.6667 2.2735 11.6667 3.84444C11.6667 5.41539 13 6.68889 14.3333 8.11111ZM14.3333 8.11111H11.2222C9.99493 8.11111 9 9.10604 9 10.3333C9 11.5606 9.99493 12.5556 11.2222 12.5556H12.2",
    stroke: "#20A8E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomigRoute);
export default __webpack_public_path__ + "static/media/upcomig_route.844e7de6d8fb9fe924df1eb2ea72ac25.svg";
export { ForwardRef as ReactComponent };